<button #buttonElement (click)="active()" [type]="type" class="button" [ngClass]="{'disabled': disabled}">
    <ng-content></ng-content>
</button>